export const REDUCER_KEY = 'transaction'

export const PAGE_SIZE = 5
